// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__G7KCX","icon":"Login_icon__1IEI-"};